import { render, staticRenderFns } from "./ExtentionSummary.vue?vue&type=template&id=152f5324"
import script from "./ExtentionSummary.vue?vue&type=script&lang=js"
export * from "./ExtentionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports